/**
 * Belt-and-suspenders hook that syncs sim mode from the current URL's
 * `?sim=` param into `sessionStorage`. `isSimMode()` already reads the URL
 * directly, so this is redundant by design — it just makes the persisted
 * flag explicit when a page mounts with `?sim=1`.
 */

import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";

import { syncSimModeFromUrl } from "./simMode";

export function useSyncSimMode(): void {
    const [searchParams] = useSearchParams();

    useEffect(() => {
        syncSimModeFromUrl(`?${searchParams.toString()}`);
    }, [searchParams]);
}
